import React, {
  useState,
  useMemo,
  createContext,
  ReactNode,
} from "react";

type BankAuthorizationDataType = {
  transfer_account?: string;
  transfer_bank?: string;
  transfer_note?: string;
};

type BankTransferContextType = {
  transferDetailsLoading: boolean;
  setTransferDetailsLoading: (arg1: boolean) => void;

  transferTabDisplayed: string;
  setTransferTabDisplayed: (arg1: string) => void;

  transferDetails: BankAuthorizationDataType;
  setTransferDetails: (arg1: BankAuthorizationDataType) => void;
  transactionRef: string;
  setTransactionRef: (arg1: string) => void;
};

export const BankTransferContext = createContext<BankTransferContextType>({
  transferDetailsLoading: false,
  setTransferDetailsLoading: (arg1) => {},
  transferTabDisplayed: "",
  setTransferTabDisplayed: (arg1) => {},
  transferDetails: {},
  setTransferDetails: (arg1) => {},
  transactionRef: "",
  setTransactionRef: (arg1) => {},
});

const BankTransfer = ({ children }: { children: ReactNode }) => {
  const [transferDetailsLoading, setTransferDetailsLoading] = useState(false);
  const [transferTabDisplayed, setTransferTabDisplayed] = useState("login");
  const [transactionRef, setTransactionRef] = useState("");
  const [transferDetails, setTransferDetails] =
    useState<BankAuthorizationDataType>({});

  const value = useMemo(
    () => ({
      transferDetailsLoading,
      setTransferDetailsLoading,
      transferTabDisplayed,
      setTransferTabDisplayed,
      transferDetails,
      setTransferDetails,
      transactionRef,
      setTransactionRef,
    }),
    [transferDetailsLoading]
  );

  return (
    <BankTransferContext.Provider value={value}>
      {children}
    </BankTransferContext.Provider>
  );
};

export default BankTransfer;
